"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _queryString = _interopRequireDefault(require("query-string"));
var _styled = _interopRequireWildcard(require("../styled"));
var _LightboxOverlayCloseButton = _interopRequireDefault(require("./LightboxOverlayCloseButton"));
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Container = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  width: 80vw;\n  max-height: 90vh;\n  padding-top: 56.25%;\n  background: ", ";\n"])), (0, _styled.prop)('theme.colors.black'));
var Iframe = _styled.default.iframe.attrs({
  frameBorder: 0,
  allowFullScreen: true
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));

/* eslint-disable react/no-unused-prop-types */

/* eslint-enable react/no-unused-prop-types */

var getOrigin = function getOrigin() {
  var _window$location = window.location,
    protocol = _window$location.protocol,
    hostname = _window$location.hostname,
    port = _window$location.port;
  return protocol + "//" + hostname + (port ? ":" + port : '');
};
var getUrl = function getUrl(props) {
  var options = _queryString.default.stringify({
    rel: +props.rel,
    showinfo: +props.showInfo,
    autoplay: +props.autoPlay,
    modestbranding: +props.modestBranding,
    origin: getOrigin()
  });
  return "https://www.youtube.com/embed/" + props.id + "?" + options;
};
var LightboxOverlayVideo = function LightboxOverlayVideo(props) {
  var src = getUrl(props);
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement(Iframe, {
    src: src,
    onClick: props.setClosed
  }), /*#__PURE__*/_react.default.createElement(_LightboxOverlayCloseButton.default, {
    onClick: props.setClosed
  }));
};
LightboxOverlayVideo.defaultProps = {
  rel: false,
  showInfo: false,
  autoPlay: true,
  modestBranding: true,
  className: undefined
};
var _default = exports.default = LightboxOverlayVideo;